import React from "react"
import { Input, InputGroup, InputGroupText } from "reactstrap"
import { MyIcon } from "src/core/components"
import Ext_Input from "./Ext_Input"
import styled from "styled-components"

class InputPassword extends Ext_Input {
  state = {
    showPassword: false,
  }
  onShowPassword = value => {
    console.warn("aaaa", value)
    this.setState({
      showPassword: value,
    })
  }
  render() {
    const { showPassword } = this.state
    return (
      <Wrap>
        <InputGroup>
          <Input
            {...this.getPropsInput()}
            type={showPassword ? "text" : "password"}
          />
          <InputGroupText
            style={{ cursor: "pointer" }}
            onClick={() => {
              this.onShowPassword(!showPassword)
            }}
          >
            <MyIcon
              data={showPassword ? "type:HiOutlineEye" : "type:HiOutlineEyeOff"}
            />
          </InputGroupText>
        </InputGroup>
      </Wrap>
    )
  }
}
const Wrap = styled.div`
  & .input-group-text {
    background-color: transparent;
    border: 0;
  }
`
export default InputPassword
